export default __webpack_public_path__ + "static/circuit2-d1af1aa236380a34c56b778e4770251b.svg";